export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "napoleon-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "napoleon-themeWrap" */'./ThemeImporter'),
  },
};
